import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
import ArticlePreview from 'containers/ArticlePreview/ArticlePreview';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Title = styled.h2`
  font-family: 'Lato', sans-serif;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
`;

export default function ArticleList({ onClick, sources }) {
  if (!sources.size) return null;

  return (
    <Fragment>
      <Title>Learn More</Title>
      <Container>
        {sources.map(source => (
          <ArticlePreview key={source} onClick={onClick} url={source} />
        ))}
      </Container>
    </Fragment>
  );
}

ArticleList.propTypes = {
  onClick: PropTypes.func,
  sources: ImmutablePropTypes.list.isRequired
};

ArticleList.defaultProps = {
  onClick: () => {}
};



// WEBPACK FOOTER //
// ./src/components/ArticleList/ArticleList.js